import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordTableDepositReport from 'views/reports/deposit_report/recordTableDepositReports'; // Importing the record table component for deposit reports
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for record deposit reports.
 * @extends JetView
 */
export default class recordDepositReportsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching from configuration
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Historial'), width: 150 }, // Label for the toolbar
                    ],
                },
                RecordTableDepositReport, // Including the record table component
                toolbar, // Adding the previously defined toolbar
            ],
        };

        // Returning the main layout configuration
        return {
            width: screen !== 'small' ? 500 : 230, // Conditional width based on screen size
            height: screen !== 'small' ? 300 : 230, // Conditional height based on screen size
            type: 'wide', // Type of layout
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
